import BookForm from "components/shared/book/form";
import { serializeReq } from "helpers/form";
import moment from "moment";
import React, { Fragment, lazy, Suspense } from "react";
import { getAllUsersForSelectList } from "sources/admin";
import { config, initialState } from "../formConfig";

const Editor = lazy(() => import("components/shared/editor.js"));

class FormPopups extends BookForm {
    setValue = ({ name, value }) => {
        const isValid = this.isValidForm({ ...this.state, [name]: value });
        this.setState({ [name]: value, ...(isValid ? { isValid: true } : {}) });
        if (name === "organizationIds") {
            this.setState({ userIds: [] });
        }
    };

    renderBody = () => {
        const { config } = this.props;
        const { organizationIds, userIds, roles, text } = this.state;
        return (
            <>
                {this.renderField(config.header)}
                <Suspense fallback={<div className="loading" />}>
                    <Editor value={text} onChange={(value) => this.setValue({ name: "text", value })} />
                </Suspense>
                {this.renderCheckbox(config.noWayToClose)}
                {this.renderDateField(config.organizationBlockDate)}
                {this.renderSelect(config.organizationIds)}
                <Fragment key={(organizationIds || []).join(",")}>
                    {this.renderSelect({
                        ...config.userIds,
                        disabled: !organizationIds?.length || roles?.length,
                        url: (params) => getAllUsersForSelectList(params, { organizationId: { in: organizationIds } }),
                    })}
                </Fragment>
                {this.renderSelect({ ...config.roles, disabled: !organizationIds?.length || userIds?.length })}
            </>
        );
    };

    onSubmit = (e) => {
        e.preventDefault();
        const { isLoading, isValid, ...state } = this.state;
        if (!isLoading) {
            if (this.isValidForm(state)) {
                this.setState({ isLoading: true, isValid: true });
                delete state.files;
                const serialized = serializeReq(state);
                if (serialized.organizationBlockDate) {
                    serialized.organizationBlockDate = moment(serialized.organizationBlockDate).format("YYYY-MM-DD");
                }
                return this.applyReq(serialized);
            }
            this.setState({ isValid: false });
        }
    };
}

const ConfiguredForm = (props) => <FormPopups {...props} config={config} initialState={initialState} />;

export default ConfiguredForm;
